module.exports = __webpack_public_path__ + "img/winter-charging.a6d4e88c.png";